import React, { useEffect, useRef, useState } from 'react'
import '../App.css';
import { GiSpikyExplosion } from 'react-icons/gi'
import { PiBalloonFill } from 'react-icons/pi'
import { AiFillDollarCircle } from 'react-icons/ai'

import data from './BalloonData.json'

const Balloons = () => {
    let [condition, setCondition] = useState('instructions')
    let [currentInd, setCurrentInd] = useState(0)
    let [pumps, setPumps] = useState(0)
    let [burst, setBurst] = useState(false)
    let [total, setTotal] = useState(0)
    let [prev, setPrev] = useState((0).toFixed(2))
    let [bursted, setBursted] = useState({
        "deepskyblue": 0,
        "red": 0,
        "orange": 0
    })
    let [score, setScore] = useState({
        "deepskyblue": 0,
        "red": 0,
        "orange": 0
    })
    const restart = () => {
        setCondition('instructions')
        setScore({
            "deepskyblue": 0,
            "red": 0,
            "orange": 0
        })
        setBursted({
            "deepskyblue": 0,
            "red": 0,
            "orange": 0
        })
        setTotal(0)
        setCurrentInd(0)
        setBurst(false)
        setPumps(0)
        setPrev((0).toFixed(2))
    }





    const pumpIt = () => {
        if (pumps >= data.balloons[currentInd].pumps - 1) {
            setBurst(true)
            const balloonColor = data.balloons[currentInd].color;
            setBursted((prevBursted) => ({
                ...prevBursted,
                [balloonColor]: prevBursted[balloonColor] + 1,
            }));
            setTimeout(() => {
                if (currentInd >= 38) {
                    setCondition('ended')
                } else {
                    setCurrentInd((prev) => prev + 1);
                    setBurst(false)
                    setPumps(0)
                    setPrev((0).toFixed(2));
                }
            }, 1000);
        } else {
            setPumps((prev) => prev + 1);
        }
    }

    const collect = () => {
        setPrev((pumps * 0.05).toFixed(2))
        if (currentInd >= 38) {
            setCondition('ended')
        } else {
            const balloonColor = data.balloons[currentInd].color;
            setScore((prevScore) => ({
                ...prevScore,
                [balloonColor]: +(prevScore[balloonColor] + pumps * 0.05).toFixed(2),
            }));
            setTotal(prev => prev + (pumps * 0.05))
            setCurrentInd((prev) => prev + 1)
            setPumps(0);
        }
    }





    const myref = useRef(null)
    return (
        <div ref={myref}>
            <div className='flex flex-row'>
                <div className='ml-auto flex flex-row'>
                    <button onClick={restart} style={{ background: '#abc4ff' }} className='text-white rounded-[10px] p-2 w-[200px] my-[10px]'>Restart</button>
                </div>
            </div>
            <div className={`shadow-xl rounded-[10px] bg-white w-[90vw] min-h-[80vh] overflow-y-auto border-[2px] text-center flex flex-col mb-5`}>
                {condition === 'instructions' ? <div className='text-left flex flex-col overflow-y-auto pl-[100px] pr-[50px] min-w-full' style={{ justifyContent: 'start', alignItems: 'start' }}>
                    <h1 className='font-bold text-[24px] mt-[50px]'>Read this before starting the game:</h1>
                    <ol>
                        <li className='text-[18px] mt-[20px]'>1. Play on computer or laptop.</li>
                        <li className='text-[18px] mt-[10px]'>2. Review the guide before playing the game.</li>
                        <li className='text-[18px] mt-[10px]'>3. Ensure you won't be interrupted during gameplay.</li>
                    </ol>
                    <h1 className='font-bold text-[24px] mt-[50px]'>Game Instructions:</h1>

                    <ul>
                        <li className='text-[18px] mt-[20px]'>
                            <div className="flex items-start">
                                <p className="mr-2">1.</p>
                                <div>In this game, your objective is to pump balloons and maximize your earnings.</div>
                            </div>
                        </li>
                        <li className='text-[18px] mt-[20px]'>
                            <div className="flex items-start">
                                <p className="mr-2">2.</p>
                                <div>There are a total of 39 rounds, and each round ends once the balloon explodes.</div>
                            </div>
                        </li>
                        <li className='text-[18px] mt-[20px]'>
                            <div className="flex items-start">
                                <p className="mr-2">3.</p>
                                <div>Click the "Pump" button to increase the balloon's size and earn $0.05 for each click.</div>
                            </div>
                        </li>
                        <li className='text-[18px] mt-[20px]'>
                            <div className="flex items-start">
                                <p className="mr-2">4.</p>
                                <div>Click the "Collect" button to gather your earnings before the balloon explodes, or you'll lose all your earnings.</div>
                            </div>
                        </li>
                        <li className='text-[18px] mt-[20px]'>
                            <div className="flex items-start">
                                <p className="mr-2">5.</p>
                                <div>The larger the balloon becomes, the greater your reward will be.</div>
                            </div>
                        </li>
                        <li className='text-[18px] mt-[20px]'>
                            <div className="flex items-start">
                                <p className="mr-2">6.</p>
                                <div>If you over-pump the balloon, it will burst, and your earnings for that balloon will disappear.</div>
                            </div>
                        </li>
                    </ul>
                    <div className='flex flex-row justify-center' style={{ alignItems: 'center', justifyContent: 'center', minWidth: '100%' }}>
                        <button className='text-white bg-slate-400 rounded-[10px] p-2 w-[200px] my-[40px]' onClick={() => setCondition('next')}>Next</button>
                    </div>
                </div>
                    : condition === 'next' ? <div className='flex flex-col justify-center'>
                        <p className='mt-[180px] text-[20px]'>Press Start when you are ready to start</p>
                        <div className='space-x-[20%] mt-[50px]'>
                            <button onClick={() => setCondition('game')} className='text-white bg-slate-400 rounded-[10px] p-2 w-[200px] my-[30px]'>Start</button>
                        </div>
                    </div>
                        : condition === 'game' ?
                            <div className='flex flex-col'>
                                <div className='flex flex-row py-[2vh]' style={{ alignItems: 'start' }}>
                                    <div className='flex flex-col w-[30%]'>
                                            <p className='text-[18px]'>Money Collected (Last Round): <b>$ {prev}</b></p>
                                        <p className='text-[18px]'>Money Collected (Cumulative): <b>$ {total.toFixed(2)}</b></p>
                                    </div>
                                    <div className='flex flex-col w-[40%]'>
                                        <p className='text-[20px]'>Money Collected</p>
                                        <div className='font-bold text-[25px]' style={{ flex: 1 }}>
                                            ${(pumps * 0.05).toFixed(2)}
                                        </div>
                                    </div>
                                    <div style={{ userSelect: 'none' }}><p className='text-start ms-[20vw] text-[1.7vw]'>{currentInd + 1}/39</p>
                                    </div>
                                </div>
                                <div className='flex flex-col' style={{ alignItems: 'center' }}>
                                    <div className='flex flex-col h-[50vh]' style={{ alignItems: 'center', justifyContent: 'end' }}>
                                        {burst && <div><GiSpikyExplosion className={`${pumps >= 70 ? 'text-[40vh]' : pumps >= 40 ? 'text-[30vh]' : 'text-[20vh]'} `} style={{ color: data.balloons[currentInd]?.color }} /></div>}
                                        {!burst && <div><PiBalloonFill style={{ fontSize: ((pumps * 2) + 100), color: data.balloons[currentInd]?.color }} /></div>}
                                    </div>
                                    <div className='flex flex-row space-x-32'>
                                        <button disabled={burst} className={`rounded-[10px] bg-slate-400 text-white px-[3vw] py-2 w-[120px]}`} onClick={pumpIt}>Pump</button>
                                        <button disabled={burst} className={`rounded-[10px] bg-slate-400 text-white px-[3vw] py-2 w-[120px]}`} onClick={collect}>Collect</button>
                                    </div>
                                </div>
                            </div>
                            : condition === 'ended' ? <div>
                                <p className='mt-[150px] text-[30px] font-bold h-[15vh]'>Test Ended</p>
                                <div>
                                    <button onClick={() => setCondition('done')} className='text-white bg-slate-400 rounded-[10px] p-2 w-[200px] my-[30px]'>Next</button>
                                </div>
                            </div>
                                : condition === "done" ? <div className='flex flex-col mt-[3vh] select-none'>
                                    <p className='font-bold text-[25px]'>Summary</p>
                                    {/* <div className='flex flex-row justify-center space-x-32 mt-[5vh]'>
                                        <p className='flex flex-row' style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <AiFillDollarCircle className='text-slate-400 text-[35px]' /><p className='ms-1 font-semibold text-[23px]'> ${total.toFixed(2)}</p>
                                        </p>
                                        <p className='flex flex-row font-semibold text-[23px]' style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            {39 - (bursted['deepskyblue'] + bursted['orange'] + bursted['red'])} / 39
                                        </p>
                                    </div> */}
                                    {/* <div className='flex flex-row justify-center space-x-10 mt-[1vh]'>
                                        <p className='flex flex-row text-[18px]' style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            Total Money Collected
                                        </p>
                                        <p className='flex flex-row text-[18px]' style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            Total Balloons Collected
                                        </p>
                                    </div> */}
                                    <div className='flex flex-row justify-center space-x-10 mt-[5vh]'>
                                        <div className='flex flex-col' style={{ alignItems: 'start', justifyContent: 'center' }}>
                                            <p className='text-[18px] mt-[30px]'></p>
                                            <p className='text-[18px] mt-[30px]'>Total Blue Balloons</p>
                                            <p className='text-[18px] mt-[30px]'>Total Orange Balloons</p>
                                            <p className='text-[18px] mt-[30px]'>Total Red Balloons</p>
                                            <p className='text-[18px] mt-[30px]'>Total Balloons</p>
                                        </div>
                                        <div className='flex flex-col' style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <p className='text-[17px] font-bold mt-[20px]'>Total Balloons Collected</p>
                                            <p className='bg-slate-100 w-[150px] select-none mt-[20px] py-[5px] text-center font-bold'>{13 - bursted['deepskyblue']} / 13</p>
                                            <p className={`bg-slate-100 w-[150px] select-none mt-[20px] py-[5px] text-center font-bold `}>{13 - bursted['orange']} / 13</p>
                                            <p className='bg-slate-100 w-[150px] select-none mt-[20px] py-[5px] text-center font-bold'>{13 - bursted['red']} / 13</p>
                                            <p className='bg-slate-100 w-[150px] select-none mt-[20px] py-[5px] text-center font-bold'>{39 - (bursted['deepskyblue'] + bursted['orange'] + bursted['red'])} / 39</p>
                                        </div>
                                        <div className='flex flex-col' style={{ alignItems: 'center', justifyContent: 'center' }}>
                                            <p className='text-[17px] font-bold mt-[20px]'>Total Money Collected</p>
                                            <p className='bg-slate-100 flex flex-row w-[150px] select-none mt-[20px] py-[5px] font-bold' style={{ alignItems: 'center', justifyContent: 'center' }}><p className='ms-1'>${score['deepskyblue'].toFixed(2)}</p></p>
                                            <p className={`bg-slate-100 flex flex-row w-[150px] select-none mt-[20px] py-[5px] font-bold `} style={{ alignItems: 'center', justifyContent: 'center' }}><p className='ms-1'>${score['orange'].toFixed(2)}</p></p>
                                            <p className='bg-slate-100 flex flex-row w-[150px] select-none mt-[20px] py-[5px] font-bold' style={{ alignItems: 'center', justifyContent: 'center' }}><p className='ms-1'>${score['red'].toFixed(2)}</p></p>
                                            <p className='bg-slate-100 flex flex-row w-[150px] select-none mt-[20px] py-[5px] font-bold' style={{ alignItems: 'center', justifyContent: 'center' }}><p className='ms-1'>${total.toFixed(2)}</p></p>
                                        </div>
                                    </div>

                                    <div className='space-x-[10%] mt-[7vh]'>
                                        <button onClick={() => setCondition('guide')} className='text-white bg-slate-400 rounded-[10px] p-2 w-[200px] my-[30px]'>Tips</button>
                                        <button onClick={restart} className='text-white bg-slate-400 rounded-[10px] p-2 w-[200px] my-[30px]'>Try again</button>
                                    </div>
                                </div>
                                    : condition === "guide" ? <div className='text-left flex flex-col overflow-y-auto pl-[50px] pr-[50px] min-w-full' style={{ justifyContent: 'start', alignItems: 'start' }}>
                                        <h1 className='font-bold text-[24px] mt-[50px]'>Tips</h1>
                                        <p className='text-[18px] mt-[20px]'>Traits Measured: <b>Risk Tolerance and Decision-Making</b></p>
                                        <h1 className='font-semibold text-[22px] mt-[50px]'>What is the game:</h1>
                                        <p className='text-[18px] mt-[20px]'>Your objective is to pump balloons and maximize your earnings.</p>
                                        <p className='text-[18px] mt-[20px]'>In this game, you are asked to push a button to pump the balloon. Each pump adds to your earnings, and you can decide when to stop and collect your money. The bigger the balloon gets, the more reward you will receive. However, if you over-pump, the balloon bursts, and your earnings for that balloon will vanish.</p>
                                        <p className='text-[18px] mt-[20px]'>The point at which the balloon explodes isn't random. Each color of balloon has its own likelihood of exploding, and this likelihood remains consistent throughout the game. However, the explosion probability for each color can differ in each test attempt.</p>
                                        <h1 className='font-semibold text-[22px] mt-[50px]'>How to tackle this game:</h1>

                                        <ul>
                                            <li className='text-[18px] mt-[20px]'>
                                                <div className="flex items-start">
                                                    <p className="mr-2">1.</p>
                                                    <div>Use the first 4 to 5 balloons to test how large a balloon can grow before it explodes.</div>
                                                </div>
                                            </li>
                                            <li className='text-[18px] mt-[20px]'>
                                                <div className="flex items-start">
                                                    <p className="mr-2">2.</p>
                                                    <div>Then, apply insights from the test to determine when to stop pumping for the remaining balloons and maximize earnings.</div>
                                                </div>
                                            </li>
                                            <li className='text-[18px] mt-[20px]'>
                                                <div className="flex items-start">
                                                    <p className="mr-2">3.</p>
                                                    <div>Remember: Larger balloons yield more rewards, but an exploded balloon results in no earnings.</div>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className='ml-auto'>
                                            <button className='text-white bg-slate-400 rounded-[10px] p-2 w-[200px] my-[30px]' onClick={() => setCondition('done')}>Back</button>
                                        </div>
                                    </div>

                                        : <div></div>
                }
            </div>
        </div>)
}

export default Balloons